module.exports = __webpack_public_path__ + "static/media/logoCentene.eb9e1353.png";